module.exports = __webpack_public_path__ + "4712634dc8cc60d4a7bb0f7cdf6c64a5.svg";